import React from 'react'
import Menu from './Menu'
const Body = () => {
  return (
    <div>
        <Menu/> 
    </div>
  )
}

export default Body